POE_API_KEY={{apiKey}}
POE_BASE_URL=https://api.poe.com/v1
MODEL={{model}}
